import styled from "styled-components";

export const ReceiptModalShell = styled.div`
  .modal-content {
    border: none;
    border-radius: 20px;
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18);
    overflow: hidden;
  }

  .modal-body {
    padding: 0;
  }

  .rp-modal-close {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.22);
    color: #fff;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    transition: background 0.15s ease;
  }

  .rp-modal-close:hover {
    background: rgba(255, 255, 255, 0.32);
  }
`;

export const EmailModalWrapper = styled.div`
  --em-primary: ${props => props.$primary || "#1F3B6F"};
  --em-secondary: ${props => props.$secondary || "#4CAF50"};
  --em-text: #1e293b;
  --em-muted: #64748b;

  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: var(--em-text);

  .em-header {
    background: linear-gradient(145deg, var(--em-primary), var(--em-secondary));
    padding: 28px 24px 24px;
    text-align: center;
    color: #fff;
  }

  .em-icon {
    width: 56px;
    height: 56px;
    margin: 0 auto 14px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.18);
    border: 1.5px solid rgba(255, 255, 255, 0.28);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .em-icon svg {
    width: 28px;
    height: 28px;
    fill: none;
    stroke: #fff;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .em-title {
    margin: 0 0 8px;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.25;
  }

  .em-subtitle {
    margin: 0;
    font-size: 14px;
    line-height: 1.45;
    opacity: 0.92;
  }

  .em-body {
    padding: 22px 22px 26px;
    background: #fff;
  }

  .em-field {
    margin-bottom: 16px;
  }

  .em-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: var(--em-muted);
    margin-bottom: 8px;
  }

  .em-input {
    width: 100%;
    border: 1.5px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 14px;
    font-size: 15px;
    color: var(--em-text);
    background: #f8fafc;
    transition: border-color 0.15s ease, box-shadow 0.15s ease,
      background 0.15s ease;
    box-sizing: border-box;
  }

  .em-input:focus {
    outline: none;
    border-color: var(--em-primary);
    background: #fff;
    box-shadow: 0 0 0 3px rgba(31, 59, 111, 0.12);
  }

  .em-input::placeholder {
    color: #94a3b8;
  }

  .em-error {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: #dc2626;
  }

  .em-consent {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px;
    border-radius: 12px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    cursor: pointer;
  }

  .em-consent input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin: 2px 0 0;
    accent-color: var(--em-primary);
    flex-shrink: 0;
    cursor: pointer;
  }

  .em-consent-text {
    font-size: 13px;
    line-height: 1.45;
    color: var(--em-muted);
  }

  .em-submit {
    width: 100%;
    margin-top: 18px;
    border: none;
    border-radius: 12px;
    padding: 14px 18px;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    background: linear-gradient(135deg, var(--em-primary), var(--em-secondary));
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.14);
    transition: transform 0.15s ease, opacity 0.15s ease;
    min-height: 48px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .em-submit:active:not(:disabled) {
    transform: scale(0.98);
  }

  .em-submit:disabled {
    opacity: 0.75;
    cursor: wait;
  }

  .em-spinner {
    width: 22px;
    height: 22px;
    border: 2.5px solid rgba(255, 255, 255, 0.35);
    border-top-color: #fff;
    border-radius: 50%;
    animation: em-spin 0.7s linear infinite;
  }

  @keyframes em-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
